/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgencyContactDto } from '../../models/agency-contact-dto';

export interface ApiAgencycontactGuidGet$Params {
  guid: string;
  'api-version'?: string;
}

export function apiAgencycontactGuidGet(http: HttpClient, rootUrl: string, params: ApiAgencycontactGuidGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgencyContactDto>> {
  const rb = new RequestBuilder(rootUrl, apiAgencycontactGuidGet.PATH, 'get');
  if (params) {
    rb.path('guid', params.guid, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgencyContactDto>;
    })
  );
}

apiAgencycontactGuidGet.PATH = '/api/agencycontact/{guid}';
